import React, { memo, useEffect } from 'react';
import Turnstile, { useTurnstile } from 'react-turnstile';

import { TURNSTYLE_SITE_KEY, env } from '../../../constants/env';

export default memo(function TurnstileWidget(props) {
  const turnstile = useTurnstile();

  useEffect(
    function () {
      if (props.isError) turnstile?.reset?.();
    },
    [props.isError]
  );
  useEffect(function () {
    return function () {
      turnstile?.reset?.();
    };
  }, []);

  function handleLoad(widgetId, bound) {
    props.onLoad?.(bound);
  }

  function handleError(errorCode, bound) {
    // this is a code: see https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/error-codes/
    // since retry is on we're not going to do anything here
  }

  // appearance="always"
  // execution="render"
  return (
    <Turnstile
      sitekey={env(TURNSTYLE_SITE_KEY)}
      fixedSize={false}
      size="normal"
      retry="auto"
      refreshExpired="auto"
      appearance="interaction-only"
      execution="execute"
      onLoad={handleLoad}
      onVerify={props.onVerify}
      onError={handleError}
    />
  );
});
